export const truncateContent = (title: string, maxLength: number) => {
  if (title.length <= maxLength) {
    return title;
  }
  return `${title.substring(0, maxLength)}...`;
};

export const removeHtmlAndTruncate = (content: string, limit: number): string => {
  const doc = new DOMParser().parseFromString(content, 'text/html');
  const plainText = doc.body.textContent || '';

  if (plainText.length <= limit) {
    return plainText;
  }
  return plainText.substring(0, limit) + '...';
};

export const isLocalDevEnv = () =>
  typeof window !== 'undefined' && window?.location?.host === 'vimeo.dev';
export const isCIEnv = () =>
  typeof window !== 'undefined' && window?.location?.host?.endsWith('.ci.vimeows.com');

/**
 * Transforms video id from the url with {video_id}
 * @param {string} path - The path to check (e.g., "/videos/123")
 * @param {string} [origin] - Optional host URL (defaults to window.location.origin)
 * @returns {string} The full constructed URL
 */
export const getTemplatedVideoUrl = (path: string, origin = window.location.origin) => {
  const checkPattern = new RegExp('(.*/videos/[0-9]+.*|.*/[0-9]+.*|/clip)');

  if (checkPattern.test(path)) {
    const regex = /(\/videos\/|^\/)(\d+)(.*)/;
    if (regex.test(path)) {
      const newPath = path.replace(regex, '$1{video_id}$3');
      return origin + newPath;
    }
  }
  return origin + path;
};
